var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.1C1 2.53995 1 2.25992 1.10899 2.04601C1.20487 1.85785 1.35785 1.70487 1.54601 1.60899C1.75992 1.5 2.03995 1.5 2.6 1.5H17.4C17.9601 1.5 18.2401 1.5 18.454 1.60899C18.6422 1.70487 18.7951 1.85785 18.891 2.04601C19 2.25992 19 2.53995 19 3.1V4.83726C19 5.08185 19 5.20414 18.9724 5.31923C18.9479 5.42127 18.9075 5.51881 18.8526 5.60828C18.7908 5.7092 18.7043 5.79568 18.5314 5.96863L12.4686 12.0314C12.2957 12.2043 12.2092 12.2908 12.1474 12.3917C12.0925 12.4812 12.0521 12.5787 12.0276 12.6808C12 12.7959 12 12.9182 12 13.1627V15.5L8 19.5V13.1627C8 12.9182 8 12.7959 7.97237 12.6808C7.94787 12.5787 7.90747 12.4812 7.85264 12.3917C7.7908 12.2908 7.70432 12.2043 7.53137 12.0314L1.46863 5.96863C1.29568 5.79568 1.2092 5.7092 1.14736 5.60828C1.09253 5.51881 1.05213 5.42127 1.02763 5.31923C1 5.20414 1 5.08185 1 4.83726V3.1Z",
    stroke: "#009A80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.8460bdc0b5fd9773a02bf7982fbe359c.svg";
export { ForwardRef as ReactComponent };